import React from 'react'

const AlertMessage = ({ message }) => (
  <div className='px-4 mx-lg-5 px-lg-5'>
    <p className='mb-0 toast-custom px-4 mx-5 mx-auto py-3'>{message}</p>
  </div>
)

export default AlertMessage
